<mat-form-field>
  <input
    [formControl]="cpfControl"
    matInput=""
    mask="000.000.000-00"
    [dropSpecialCharacters]="true"
    placeholder="{{ 'EnterYourCPF' | translate }}"
    [required]="!question.elective"
    [attr.inputmode]="inputMode"
    [attr.autocomplete]="autocomplete"
    aria-label="CPF"
    aria-describedby="cpf-error"
    pattern="[0-9]*"
    (blur)="onBlur()"
  />

  <mat-error *ngIf="showErrors && cpfControl.errors && cpfControl.errors['required']">
    {{ "CPFRequired" | translate }}
  </mat-error>
  <mat-error *ngIf="showErrors && cpfControl.errors && cpfControl.errors['invalidLength']">
    {{ "CPFInvalidLength" | translate }}
  </mat-error>
  <mat-error *ngIf="showErrors && cpfControl.errors && cpfControl.errors['invalidCpf']">
    {{ "InvalidCPF" | translate }}
  </mat-error>
</mat-form-field>
